import { NetworkPointResource } from 'app/_resources/network-point.resource';

import * as angular from 'angular';
import { DATES } from 'app/_constants/dates.constant';

(function () {
    'use strict';

    angular.module('app').controller('DashboardCtrl', DashboardCtrl);

    function DashboardCtrl(
        $rootScope,
        $log,
        $scope,
        dashboardService,
        activitiesService,
        authService,
        NetworkPoint: NetworkPointResource,
        TradeProposals,
        ShipperUser,
        Shipper,
        Activity,
        auctionResource,
        storageOfferResource,
        networkPointSearchService,
        createProposalService,
        createComfortBidService,
        secondaryTradingService,
        ttpcModulationService,
        DATES: DATES
    ) {
        var vm = this;

        vm.appBaseUrl = $rootScope.stageConfig.appBaseUrl;
        vm.snamBiddingUrl = $rootScope.stageConfig.appBaseUrl + '/snam-bidding';
        vm.ttpcModulationServiceUrl =
            $rootScope.stageConfig.appBaseUrl + '/modulation-service-auctions';
        vm.DATES = dashboardService.ENUMS.DATES;
        vm.INPUT_ADDON = networkPointSearchService.INPUT_ADDON;
        vm.loggedIn = dashboardService.loggedIn;
        vm.isLoggedIn = null;
        vm.widgets = dashboardService.settings.widgets;
        vm.recentActivitiesForCompany =
            dashboardService.settings.recentActivitiesForCompany;
        vm.activityList = {};
        vm.deletedProposalSuccessfully = null;
        vm.withdrawnProposalSuccessfully = null;
        vm.auctionTiles = [];
        vm.biddableAuctions = {
            biddableNwps: []
        };
        vm.operators = [];
        vm.uiLoading = {};
        vm.uiLoadingNwpAuctions = {};
        vm.createTradeProposal = createTradeProposal;
        vm.showProposalsToBuy = showProposalsToBuy;
        vm.showProposalsToSell = showProposalsToSell;
        vm.createComfortBid = createComfortBid;
        vm.deleteProposal = deleteProposal;
        vm.deleteBid = deleteBid;
        vm.deleteStorageBid = deleteStorageBid;
        vm.uiPlaceBidSuccess = 'dashboard-sta-bid-placed';
        vm.nwpPaginator = {
            itemsPerPage: 5,
            currentPage: 0
        };
        vm.nwpChangePageNumber = nwpChangePageNumber;
        vm.ummExists = ummExists;
        vm.onStaBidSuccess = onStaBidSuccess;
        vm.DATES = DATES;
        init();

        function init() {
            ShipperUser.loggedInShipperUser({}, function (res) {
                if ($.isEmptyObject(res.toJSON())) {
                    authService.logOut();
                }
                dashboardService.saveShipperUser(res);
                vm.isLoggedIn = !!res.email;
                if (vm.isLoggedIn) {
                    fetchData();
                }
            });

            Shipper.loggedInShipper({}, function (res) {
                if ($.isEmptyObject(res.toJSON())) {
                    authService.logOut();
                }
                dashboardService.saveShipper(res);
            });

            fetchSnamBidCollector();

            ttpcModulationService.data.then((data) => {
                vm.isTtpcModulationServiceEnabled =
                    data.active && data._links.modulationAuctions;
                vm.ttpcAuctionTileInformation = data.auctionTileInformation;
            });
        }

        function fetchSnamBidCollector() {
            if (!$rootScope.stageConfig.snamBidCollector21) return;

            fetch($rootScope.stageConfig.snamBidCollector21)
                .then((response) => response.json())
                .then((data) => {
                    vm.isSnamBidCollectorEnabled =
                        data.enabled && data.nonEmpty;
                })
                .catch(() => null);
        }

        function fetchData() {
            ShipperUser.getSettings({ setting: 'platform' }, function (res) {
                dashboardService.savePlatformSettings(res);
                vm.recentActivitiesForCompany =
                    dashboardService.settings.recentActivitiesForCompany;
            });

            ShipperUser.getSettings({ setting: 'dashboard' }, function (res) {
                dashboardService.saveDashboardSettings(res);

                vm.widgets = dashboardService.settings.widgets;

                for (
                    var i = 0;
                    i < dashboardService.settings.widgets.length;
                    i++
                ) {
                    var widget = dashboardService.settings.widgets[i];

                    if (
                        widget.key === dashboardService.ENUMS.WIDGETS.AUCTIONS
                    ) {
                        fetchAuctionTiles();
                    }

                    if (
                        widget.key ===
                        dashboardService.ENUMS.WIDGETS.NETWORK_POINTS
                    ) {
                        fetchFavoriteNetworkPoints();
                    }

                    if (
                        widget.key === dashboardService.ENUMS.WIDGETS.ACTIVITIES
                    ) {
                        fetchActivities();
                    }

                    if (
                        widget.key === dashboardService.ENUMS.WIDGETS.PROPOSALS
                    ) {
                        fetchProposals(null);
                    }
                }
            });
        }

        function fetchAuctionTiles() {
            vm.uiLoading.auctionTiles = true;
            auctionResource.tiles(
                {},
                function (res) {
                    vm.auctionTiles = res;
                    vm.uiLoading.auctionTiles = false;
                },
                function () {
                    vm.uiLoading.auctionTiles = false;
                }
            );
        }

        function fetchFavoriteNetworkPoints() {
            vm.uiLoading.favoriteNetworkPoints = true;
            NetworkPoint.favoritesPage(
                {
                    start: vm.nwpPaginator.currentPage,
                    pageSize: vm.nwpPaginator.itemsPerPage
                },
                function (res) {
                    vm.favoriteNetworkPoints = res;
                    for (var i = 0; i < res.length; i++) {
                        if (res[i].actions.indexOf('CREATE_FCFS_ORDER') > -1) {
                            $log.debug(res[i].name);
                        }
                    }
                    vm.uiLoading.favoriteNetworkPoints = false;
                },
                function (err) {
                    $log.error(err);
                    vm.uiLoading.favoriteNetworkPoints = false;
                }
            );
        }

        function nwpChangePageNumber(newPageNumber) {
            vm.nwpPaginator.currentPage =
                (newPageNumber - 1) * vm.nwpPaginator.itemsPerPage;
            fetchFavoriteNetworkPoints();
        }

        function fetchActivities() {
            vm.uiLoading.activityList = true;
            var from = new Date();
            from.setDate(from.getDate() - 1);

            Activity.query(
                { from: from },
                function (res) {
                    vm.activityList = activitiesService.map(res.data);
                    vm.uiLoading.activityList = false;
                },
                function (err) {
                    $log.error(err);
                    vm.uiLoading.activityList = false;
                }
            );
        }

        function fetchProposals(mode) {
            if (angular.isUndefined(vm.proposals)) {
                vm.proposals = {
                    paginator: {
                        itemsPerPage: 5,
                        currentPage: 1
                    }
                };
                $scope.$watch(
                    function () {
                        return vm.proposals.paginator.currentPage;
                    },
                    function () {
                        fetchProposals('paging_my');
                    }
                );
            }
            if (angular.isUndefined(mode) || mode === 'paging_my') {
                if (mode !== 'paging_my') {
                    vm.uiLoading.proposalsPage = true;
                }
                TradeProposals.page(
                    {
                        sortColumn: 'proposalId',
                        sortAscending: false,
                        mode: 'my',
                        pageSize: vm.proposals.paginator.itemsPerPage,
                        start:
                            (vm.proposals.paginator.currentPage - 1) *
                            vm.proposals.paginator.itemsPerPage
                    },
                    function (res) {
                        vm.proposals.page = res;
                        vm.uiLoading.proposalsPage = false;
                    },
                    function (err) {
                        $log.error(err);
                        vm.uiLoading.proposalsPage = false;
                    }
                );
            }

            if (angular.isUndefined(vm.proposalsAtOwnNetworkPoints)) {
                vm.proposalsAtOwnNetworkPoints = {
                    paginator: {
                        itemsPerPage: 5,
                        currentPage: 1
                    }
                };
                $scope.$watch(
                    function () {
                        return vm.proposalsAtOwnNetworkPoints.paginator
                            .currentPage;
                    },
                    function () {
                        fetchProposals('paging_atMyNetworkPoints');
                    }
                );
            }
            if (
                angular.isUndefined(mode) ||
                mode === 'paging_atMyNetworkPoints'
            ) {
                if (mode !== 'paging_atMyNetworkPoints') {
                    vm.uiLoading.proposalsAtOwnNetworkPointsPage = true;
                }
                TradeProposals.page(
                    {
                        sortColumn: 'proposalId',
                        sortAscending: false,
                        mode: 'atMyNetworkPoints',
                        pageSize:
                            vm.proposalsAtOwnNetworkPoints.paginator
                                .itemsPerPage,
                        start:
                            (vm.proposalsAtOwnNetworkPoints.paginator
                                .currentPage -
                                1) *
                            vm.proposalsAtOwnNetworkPoints.paginator
                                .itemsPerPage
                    },
                    function (res) {
                        vm.proposalsAtOwnNetworkPoints.page = res;
                        vm.uiLoading.proposalsAtOwnNetworkPointsPage = false;
                    },
                    function (err) {
                        $log.error(err);
                        vm.uiLoading.proposalsAtOwnNetworkPointsPage = false;
                    }
                );
            }
        }

        function createComfortBid(netPoint) {
            createComfortBidService.setNetworkPoint(netPoint);
        }

        function createTradeProposal(netPoint) {
            createProposalService.setNetworkPoint(netPoint);
        }

        function showProposalsToBuy(netPoint) {
            secondaryTradingService.setMode('PROPOSAL_TO_BUY');
            secondaryTradingService.setPreselectedNetworkPoint(netPoint);
        }

        function showProposalsToSell(netPoint) {
            secondaryTradingService.setMode('PROPOSAL_TO_SELL');
            secondaryTradingService.setPreselectedNetworkPoint(netPoint);
        }

        function deleteProposal(id, index) {
            var param = {
                id: id
            };
            TradeProposals.delete(
                param,
                function () {
                    if (vm.proposals.page.data[index].state == 'NEW') {
                        vm.deletedProposalSuccessfully = true;
                    } else {
                        vm.withdrawnProposalSuccessfully = true;
                    }
                    vm.proposals.page.data.splice(index, 1);
                    fetchProposals('paging_my');
                },
                function () {
                    if (vm.proposals.page.data[index].state == 'NEW') {
                        vm.deletedProposalSuccessfully = false;
                    } else {
                        vm.withdrawnProposalSuccessfully = false;
                    }
                }
            );
        }

        function deleteBid(index, bidId) {
            auctionResource.deleteBid(
                { id: bidId },
                function () {
                    delete vm.activityList.activities[index];
                    vm.uiDeleteBidSuccess = true;
                },
                function () {
                    vm.uiDeleteBidError = true;
                }
            );
        }

        function deleteStorageBid(index, bidId) {
            storageOfferResource
                .deleteBid(
                    { id: bidId },
                    () => {
                        delete vm.activityList.activities[index];
                        vm.uiDeleteBidSuccess = true;
                    },
                    (err: any) => {
                        vm.uiDeleteBidError = true;
                    }
                )
                .$promise.finally(() => (this.deletionLoading = false));
        }

        function ummExists() {
            var checkUmm = angular.element(
                document.querySelector('#umm-identifier')
            );
            if (checkUmm[0]) {
                return true;
            } else {
                return false;
            }
        }

        function onStaBidSuccess() {
            $rootScope.$broadcast(vm.uiPlaceBidSuccess);
            fetchActivities();
        }
    }
})();
